import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    questions: [],
    infiniteDurationQues: 0,
    currentQuestion: {},
    questionNo: 0,
    currentScenarioQuesNo: 0,
    answers: {},
    recordingTime: 0,
    totalQuestion: 0,
    practiceQNo: 0,
    practiceQuestion: [],
    currentPracticeQuestion: {},
    blurBackground: false,
    customBackground: "",
    currentAnswerByVoiceCommand: "",
    chatInputByVoiceCommand: "",
    waterMark: "",
    isHideWatermark: false,
    currentMatchCmd: null,
    hidePractice: false,
    remainingQuestions: 0,
    typingData: {},
    questions_randomized: 0,
    practiceQuestions: [],
    currentPracticeQuestionIndex: 0,
    welcomeNote: "",
    exitNote: "",
    questionAndSlide: 0,
    slides: {
        remainSlide: 0,
        totalSlide: 0
    }
};

const questionSlice = createSlice({
    name: "question",
    initialState,
    reducers: {
        setQuestions: (state, { payload }) => {
            state.questions = payload;
        },
        addNewQuestion: (state, { payload }) => {
            state.questions = [...state.questions, payload];
        },
        setInfiniteDurationQues: (state, { payload }) => {
            state.infiniteDurationQues = payload;
        },
        setCurrentQuestion: (state, { payload }) => {
            state.currentQuestion = payload;
        },
        setCurrentScenarioQuesNo: (state, { payload }) => {
            state.currentScenarioQuesNo = payload;
        },
        setQuestionNo: (state, { payload }) => {
            state.questionNo = payload;
        },
        setAnswers: (state, { payload }) => {
            state.answers = { ...state.answers, [payload.id]: { answer: payload.answer, retakes: payload.retakes, attempts: payload.attempts, skipAnswer: payload.skipAnswer, selected_language: payload.selected_language } };
        },
        setRecordingTime: (state, { payload }) => {
            state.recordingTime = payload;
        },
        setTotalQuestion: (state, { payload }) => {
            state.totalQuestion = payload;
        },
        setPracticeQuestion: (state, { payload }) => {
            state.practiceQuestion = payload;
        },
        setCurrentPracticeQuestion: (state, { payload }) => {
            state.currentPracticeQuestion = payload;
        },
        setPracticeQNo: (state, { payload }) => {
            state.practiceQNo = payload;
        },
        setBlurBackground: (state, { payload }) => {
            state.blurBackground = payload;
        },
        setCustomBackground: (state, { payload }) => {
            state.customBackground = payload;
        },
        setCurrentAnswerByVoiceCommand: (state, { payload }) => {
            state.currentAnswerByVoiceCommand = payload;
        },
        setChatInputByVoiceCommand: (state, { payload }) => {
            state.chatInputByVoiceCommand = payload;
        },
        setWaterMark: (state, { payload }) => {
            state.waterMark = payload;
        },
        setIsHideWatermark: (state, { payload }) => {
            state.isHideWatermark = payload;
        },
        setCurrentMatchCmd: (state, { payload }) => {
            state.currentMatchCmd = payload;
        },
        setHidePractice: (state, { payload }) => {
            state.hidePractice = payload;
        },
        setRemainingQuestions: (state, { payload }) => {
            state.remainingQuestions = payload;
        },
        setTypingData: (state, { payload }) => {
            state.typingData = payload;
        },
        setQuestionsRandomized: (state, { payload }) => {
            state.questions_randomized = payload;
        },
        setPracticeQuestions: (state, { payload }) => {
            state.practiceQuestions = payload;
        },
        setCurrentPracticeQuestionIndex: (state, { payload }) => {
            state.currentPracticeQuestionIndex = payload;
        },
        setWelcomeNote: (state, { payload }) => {
            state.welcomeNote = payload;
        },
        setExitNote: (state, { payload }) => {
            state.exitNote = payload;
        },
        setQuestionAndSlide : (state, { payload}) =>{
            state.questionAndSlide = payload
        },
        setSlides : (state, { payload}) =>{
            state.slides = payload
        }
    },
});

export const { setQuestions, setCurrentScenarioQuesNo, setPracticeQuestion, setInfiniteDurationQues, setTotalQuestion, setPracticeQNo, setCurrentPracticeQuestion, setCurrentQuestion, setQuestionNo, setAnswers, setRecordingTime, setCustomBackground, setBlurBackground, setCurrentAnswerByVoiceCommand, setChatInputByVoiceCommand, setWaterMark, setIsHideWatermark, setCurrentMatchCmd, setHidePractice, setRemainingQuestions, setTypingData, setQuestionsRandomized, setPracticeQuestions, setCurrentPracticeQuestionIndex, setWelcomeNote, setExitNote, addNewQuestion, setQuestionAndSlide, setSlides } = questionSlice.actions;

export const getQuestions = (state) => state.question.questions;
export const getInfiniteDurationQues = (state) => state.question.infiniteDurationQues;
export const getCurrentQuestion = (state) => state.question.currentQuestion;
export const getCurrentScenarioQuesNo = (state) => state.question.currentScenarioQuesNo;
export const getQuestionNo = (state) => state.question.questionNo;
export const getAnswers = (state) => state.question.answers;
export const getRecordingTime = (state) => state.question.recordingTime;
export const getTotalQuestion = (state) => state.question.totalQuestion;
export const getPracticeQuestion = (state) => state.question.practiceQuestion;
export const getCurrentPracticeQuestion = (state) => state.question.currentPracticeQuestion;
export const getPracticeQNo = (state) => state.question.practiceQNo;
export const getBlurBackground = (state) => state.question.blurBackground;
export const getCustomBackground = (state) => state.question.customBackground;
export const getCurrentAnswerByVoiceCommand = (state) => state.question.currentAnswerByVoiceCommand;
export const getChatInputByVoiceCommand = (state) => state.question.chatInputByVoiceCommand;
export const getWaterMark = (state) => state.question.waterMark;
export const getIsHideWaterMark = (state) => state.question.isHideWatermark;
export const getCurrentMatchCmd = (state) => state.question.currentMatchCmd;
export const getHidePractice = (state) => state.question.hidePractice;
export const getRemainingQuestions = (state) => state.question.remainingQuestions;
export const getTypingData = (state) => state.question.typingData;
export const getQuestionsRandomized = (state) => state.question.questions_randomized;
export const getPracticeQuestions = (state) => state.question.practiceQuestions;
export const getCurrentPracticeQuestionIndex = (state) => state.question.currentPracticeQuestionIndex;
export const getWelcomeNote = (state) => state.question.welcomeNote;
export const getExitNote = (state) => state.question.exitNote;
export const getQuestionsLength = (state) => state.question.questions?.length;
export const getQuestionAndSlide =(state) => state.question.questionAndSlide;
export const getSlides = (state) => state.question.slides

export default questionSlice.reducer;
